// extracted by mini-css-extract-plugin
export default {"twoCols":"styles_twoCols__HbvH6","twoColsInner":"styles_twoColsInner__ji94c","colContent":"styles_colContent__IEgiK","colForm":"styles_colForm__VORCW"};